import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, forkJoin, map } from 'rxjs';
import { OrderDraftItem, OrderListItem, OrdersQuickFilters, PagedResult } from '../interfaces/order-list.model';

export interface OrdersSort {
  propertyName: string;
  orderType: 'Asc' | 'Desc';
}

@Injectable({ providedIn: 'root' })
export class OrdersService {
  private readonly http = inject(HttpClient);

  // Senza ordinamento il backend parte dall'ordine più recente
  getOrders(page: number, pageSize: number, searchText: string, filtroRapido: string | null, orderBy: OrdersSort[] = []): Observable<PagedResult<OrderListItem>> {
    return this.http.post<PagedResult<OrderListItem>>(
      'api/ordini/list',
      { ...this.ordersBody(searchText, filtroRapido), ...(orderBy.length ? { orderBy } : {}) },
      { params: { page, pageSize } },
    );
  }

  // I contatori seguono la ricerca ma non il filtro rapido scelto; «Tutti gli ordini» è il totale della lista
  getQuickFilters(searchText: string): Observable<OrdersQuickFilters & { tutti: number }> {
    const body = this.ordersBody(searchText, null);
    return forkJoin({
      quickFilters: this.http.post<OrdersQuickFilters>('api/ordini/pulsantiera', body),
      all: this.http.post<PagedResult<OrderListItem>>('api/ordini/list', body, { params: { page: 1, pageSize: 1 } }),
    }).pipe(map(({ quickFilters, all }) => ({ ...quickFilters, tutti: all.totalItems })));
  }

  // Senza ordinamento il backend parte dalla bozza modificata più di recente
  getDrafts(page: number, pageSize: number, searchText: string, conPreventivo: boolean, orderBy: OrdersSort[] = []): Observable<PagedResult<OrderDraftItem>> {
    return this.http.post<PagedResult<OrderDraftItem>>(
      'api/ordini/bozze/list',
      { searchText: { text: searchText }, searchObject: { conPreventivo }, ...(orderBy.length ? { orderBy } : {}) },
      { params: { page, pageSize } },
    );
  }

  deleteDraft(idOrdine: string): Observable<void> {
    return this.http.delete<void>(`api/ordini/${idOrdine}/bozza`);
  }

  private ordersBody(searchText: string, filtroRapido: string | null): object {
    return {
      searchText: { text: searchText },
      searchObject: filtroRapido ? { filtroRapido } : {},
    };
  }
}
